import React from "react";

export default function useUserGestureFlag(timeoutMs = 1500) {
  const lastGestureAt = React.useRef(0);

  React.useEffect(() => {
    const mark = () => {
      lastGestureAt.current = Date.now();
    };

    // capture phase catches events even if widgets don't forward handlers
    window.addEventListener("pointerdown", mark, true);
    window.addEventListener("keydown", mark, true);
    window.addEventListener("paste", mark, true);

    return () => {
      window.removeEventListener("pointerdown", mark, true);
      window.removeEventListener("keydown", mark, true);
      window.removeEventListener("paste", mark, true);
    };
  }, []);

  return () => Date.now() - lastGestureAt.current < timeoutMs;
}
